<template>
  <div class="w-100 p-2 mt-2">
    <page-header>
      <i class="fas fa-list"></i> {{ $t('page.title.user_segment_player') }}
      <template v-slot:right>
        <b-button v-required-role="'ROLE_BACKOFFICE_GROUP_POST'" class="mr-1" @click="exportCsvFile()" size="sm"
                  variant="primary">
          {{ $t('segment.btn.export_segment_players') }}
        </b-button>
        <router-link :to="{ name: 'user-segment-list'}"><b-button size="sm" variant="outline-primary">{{ $t('btn.segment.back_to_segment_list') }}</b-button></router-link>
      </template>
    </page-header>
    <page-card>
      <template v-slot:header>
        {{ $t('page.filters') }}
      </template>
      <template v-slot:content>
        <div class="sygni-grid">
          <div class="row">
            <div class="col-4">
              <filter-input
                  :filter-query="filterQuery"
                  :filter-operator="'like'"
                  filter-name="playerEmail"
                  :label="$t('filters.label.question_list_phrase')"
                  :placeholder="$t('filters.placeholder.question_list_phrase')">
              </filter-input>
            </div>

            <div class="col-4">
              <filter-select
                  :filter-query="filterQuery"
                  :options="selectOptions.isStatic"
                  :multiple="false"
                  options-label="text"
                  options-track-by="value"
                  filter-name="isStatic"
                  :label="$t('filters.label.type')"
                  :placeholder="$t('filters.placeholder.type')">
              </filter-select>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <b-button @click="resetFilters()" variant="secondary">{{ $t('filters.btn.clear') }}</b-button>
        <b-button @click="applyFilters()" variant="primary">{{ $t('filters.btn.apply') }}</b-button>
      </template>
    </page-card>

    <page-card>
      <template v-slot:header>
        {{ $t('page.list') }}
      </template>
      <template v-slot:content>
        <div class="sygni-grid">
          <div class="pagination-wrapper">
            <grid-pagination :total-count="totalCount"
                             :per-page="perPage"
                             :current-page="currentPage"
                             @load-items="paginationReload"></grid-pagination>
          </div> <!-- #pagination-wrapper-->

          <div class="table-responsive">
            <b-table striped show-empty
                     :empty-text="$t('table.no_results')"
                     :busy="isBusy"
                     hover
                     head-variant="dark"
                     outlined

                     :no-local-sorting="true"
                     :items="players"
                     :fields="fields">

              <template #cell(playerId)="data">
                <div>{{data.value | shortId}}</div>
              </template>

              <template #cell(segmentId)="data">
                <div>{{data.value | shortId}}</div>
              </template>

              <template #cell(createdAt)="data">
                <div>{{data.value | dateFormat('YYYY-MM-DD HH:mm:ss')}}</div>
              </template>

              <template #cell(lastLogin)="data">
                <div>{{data.value | dateFormat('YYYY-MM-DD HH:mm:ss')}}</div>
              </template>

              <template #cell(actions)="data">
                <div class="table-action--cell">
                  <b-button variant="primary" size="sm" @click="showItem(data.item)">
                    {{ $t('table.btn.show') }}
                  </b-button>
                </div>
              </template>

              <template #table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>{{ $t('state.loading') }}</strong>
                </div>
              </template>

            </b-table>
          </div> <!-- #table-responsive-->

          <grid-pagination :total-count="totalCount"
                           :per-page="perPage"
                           :current-page="currentPage"
                           @load-items="paginationReload"></grid-pagination>
        </div>
      </template>
      <template v-slot:footer>
      </template>
    </page-card>
  </div>

</template>

<script>
import FilterInput from "../../../components/grid/filters/FilterInput";
import FilterSelect from "../../../components/grid/filters/FilterSelect";
import GridPagination from "../../../components/grid/grid-pagination/GridPagination";
import PageHeader from "../../../components/page/PageHeader";
import PageCard from "../../../components/page/PageCard";
import ShowPlayerModal from "../components/ShowPlayerModal";
import Vue from "vue";
import axios from "axios";
import alertify from "alertifyjs";

export default {
  props: ['apiKey'],
  components: {
    PageCard,
    PageHeader,
    FilterSelect,
    FilterInput,
    GridPagination,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      filterQuery: [],
      fields: [
        {key: 'playerId', label: this.$t('table.header.segment.player_id')},
        {key: 'name', label: this.$t('table.header.segment.player_name')},
        {key: 'nickName', label: this.$t('table.header.segment.player_nick_name')},
        {key: 'playerEmail', label: this.$t('table.header.segment.player_email')},
        {key: 'phone', label: this.$t('table.header.segment.player_phone')},
        {key: 'country', label: this.$t('table.header.segment.player_country')},
        {key: 'depositCount', label: this.$t('table.header.segment.player_deposit_count')},
        {key: 'quizCoinsBalance', label: this.$t('table.header.segment.player_quiz_coins_balance')},
        {key: 'funCoinsBalance', label: this.$t('table.header.segment.player_fun_coins_balance')},
        {key: 'lastLogin', label: this.$t('table.header.segment.player_last_login')},
        {key: 'createdAt', label: this.$t('table.header.segment.player_created_at')},
        {key: 'segmentId', label: this.$t('table.header.segment.player_segment_id')},
        {key: 'actions', label: this.$t('table.header.actions')}
      ],
      selectOptions: {
        isStatic: [
          {value: 1, text: this.$t('option.segment.static')},
          {value: 0, text: this.$t('option.segment.dynamic')},
        ]
      },
      showModalInstance: null
    };
  },
  computed: {
    filters: function () {
      return this.$store.getters["root/filter"]('players');
    },
    isBusy: function () {
      return this.$store.getters["userSegment/isBusy"];
    },
    players: function () {
      return this.$store.getters["userSegment/players"];
    },
    totalCount: function () {
      return this.$store.getters["userSegment/playersTotalCount"];
    },
  },
  mounted() {
    this.loadItems();

    this.$on('refreshGrid', () => {
      this.applyFilters();
    })
  },
  methods: {
    loadItems() {
      this.$store.dispatch('userSegment/loadSegmentPlayers', {
        params: {
          offset: this.perPage * (this.currentPage - 1),
          limit: this.perPage
        },
        filters: this.filterQuery,
        sort: this.createSortQuery(),
        id: this.$route.params.id
      });
    },
    paginationReload(data) {
      this.currentPage = data.currentPage;
      this.perPage = data.perPage;
      this.loadItems();
    },
    // backToSegmentList() {
    //   this.$router.push({ name: 'user-segment-list' });
    // },
    createSortQuery() {
      // let sorting;
      // if (this.orderColumn) {
      //   if (this.orderDirection === true) {
      //     sorting = encodeURIComponent('+' + this.orderColumn);
      //   } else {
      //     sorting = encodeURIComponent('-' + this.orderColumn);
      //   }
      //   return '&sort[]=' + sorting;
      // }
      return '';
    },
    openModal(type) {
      let ModalConstructor;

      switch (type) {
        case('show'): {
          if(!this.showModalInstance){
            ModalConstructor = Vue.extend(ShowPlayerModal)
            this.showModalInstance = new ModalConstructor({parent: this});
            this.showModalInstance.$mount();
          } else {
            this.showModalInstance.showModal();
          }
        }
      }
    },
    showItem(data) {
      this.$router.push(`/player/${data.playerId}/details`);
    },
    applyFilters: function () {
      this.currentPage = 1;
      this.loadItems();
    },
    resetFilters() {
      this.$root.$emit('resetFilters');
      this.filterQuery = [];
      this.applyFilters();
    },
    deleteItem(item) {
      this.$bvModal.msgBoxConfirm(this.$t('segment.delete.title') + item.name, {
        title: this.$t('segment.delete.are_you_sure'),
        okTitle: this.$t('btn.segment.delete'),
        cancelTitle: this.$t('btn.segment.cancel'),
        okVariant: 'danger',
      })
      .then(value => {
        if (value) {
          this.$store.dispatch('userSegment/deleteSegment', item.id).then(() => {
            this.applyFilters();
          });
        }
      });
    },
    exportCsvFile() {
      const segmentId = this.$route.params.id;
      const segmentName = this.$route.query.segmentName;

      axios.get(`/api/segment/${segmentId}/players/export`)
          .then((response) => {
            const hiddenElement = document.createElement('a');
            hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(response.data);
            hiddenElement.target = '_blank';
            hiddenElement.download = `Segment-${segmentName}.csv`;
            hiddenElement.click();
          })
          .catch((error) => {
            alertify.error('Something went wrong');
            console.log(error);
          });
    }
  }
}
</script>

